export default __webpack_public_path__ + "static/media/play.6e38ec93.svg";